import React from "react"
import Form from "@rjsf/core"
import { useShallow } from "zustand/react/shallow"
import Loading from "components/Loading/Loading"

// widgets
import RJTextInput from "./widgets/RJTextInput/RJTextInput"
import RJTextArea from "./widgets/RJTextArea/RJTextArea"
import RJDropdown from "./widgets/RJDropdown/RJDropdown"
import RJRadio from "./widgets/RJRadio/RJRadio"
import RJDatePicker from "./widgets/RJDatePicker/RJDatePicker"
import RJMultiSelect from "./widgets/RJMultiselect/RJMultiselect"
import RJCheckboxGroup from "./widgets/RJCheckboxGroup/RJCheckboxGroup"
import RJLookahead from "./widgets/RJLookahead/RJLookahead"
import RJMoreInfoAgeRange from "./widgets/RJMoreInfoAgeRange/RJMoreInfoAgeRange"
import RJTrialCountries from "./widgets/RJTrialCountries/RJTrialCountries"
import RJCopyEUPASContactCheckbox from "./widgets/RJCopyEUPASContactCheckbox/RJCopyEUPASContactCheckbox"
import RJCopyTextArea from "./widgets/RJCopyTextArea/RJCopyTextArea"
import RJTypeUnitsAssigned from "./widgets/RJTypeUnitsAssigned/RJTypeUnitsAssigned"
import RJSingleCheckbox from "./widgets/RJSingleCheckbox/RJSingleCheckbox"
import MSCWrapper from "./widgets/MemberStatesConcerned/MSCWrapper"
import RJSelectTag from "./widgets/RJSelectTag/RJSelectTag"
import RJFreeMultiSelect from "./widgets/RJFreeMultiSelect/RJFreeMultiSelect"

// reformatted tables
import ParticipantWrapper from "./widgets/RJParticipantFlow/ParticipantWrapper"
import BaselineWrapper from "./widgets/RJBaselineChars/BaselineWrapper"
import OutcomeWrapper from "./widgets/RJOutcomeMeasures/OutcomeWrapper"
import AdverseWrapper from "./widgets/RJAdverseEvents/AdverseWrapper"
import SimpleTableWrapper from "./widgets/RJSimpleTable/SimpleTableWrapper"
import CrossReferenceWrapper from "./widgets/RJCrossReferenceTable/CrossReferenceWrapper"

// context
import useAuthoringViewStore from "containers/studies/Study/subcomponents/Authoring/hooks/stores/useAuthoringViewStore"

// styles
import "styles/authoring-print.scss"

const RJForm = ({ schema, uiSchema, onChange, ObjectFieldTemplate, ArrayFieldTemplate, formData, formContext }) => {
  const { isReviewerView, showNav, formSection, formWidthClassName, fullScreen, loadingForm } = useAuthoringViewStore(
    useShallow((state) => ({
      readOnly: state.readOnly,
      formView: state.formView,
      formSection: state.formSection,
      showVersionCompare: state.showVersionCompare,
      isReviewerView: state.isReviewerView,
      showPanel: state.showPanel,
      showNav: state.showNav,
      formWidthClassName: state.formWidthClassName,
      fullScreen: state.fullScreen,
      loadingForm: state.loadingForm,
    }))
  )

  const widgets = {
    TextWidget: RJTextInput,
    SelectWidget: RJDropdown,
    TextareaWidget: RJTextArea,
    RadioWidget: RJRadio,
    DateWidget: RJDatePicker,
    MultiSelect: RJMultiSelect,
    CustomCheckboxGroup: RJCheckboxGroup,
    SingleCheckbox: RJSingleCheckbox,
    Lookahead: RJLookahead,
    SimpleTable: SimpleTableWrapper,
    CrossReferenceTable: CrossReferenceWrapper,
    ParticipantFlow: ParticipantWrapper,
    BaselineCharacteristics: BaselineWrapper,
    OutcomeMeasures: OutcomeWrapper,
    AdverseEvents: AdverseWrapper,
    AgeRange: RJMoreInfoAgeRange,
    TrialCountries: RJTrialCountries,
    CopyContact: RJCopyEUPASContactCheckbox,
    CopyTextArea: RJCopyTextArea,
    TypeUnitsAssigned: RJTypeUnitsAssigned,
    MemberStatesConcerned: MSCWrapper,
    SelectTag: RJSelectTag,
    FreeMultiSelect: RJFreeMultiSelect,
  }

  let classNames = ["authoring-print-page", `form-section-${formSection?.id}`, "rjs-form"]

  if (!isReviewerView) {
    classNames.push(formWidthClassName)
  }

  if (showNav && fullScreen === false) {
    classNames.push("auth-form--open-nav")
  }

  if (loadingForm) return <Loading />

  return (
    <div
      id="auth-rjs-form"
      className={classNames.join(" ")}
    >
      <Form
        noValidate={true}
        formData={formData}
        idSeparator={"."}
        schema={schema}
        uiSchema={uiSchema}
        widgets={widgets}
        ObjectFieldTemplate={ObjectFieldTemplate}
        ArrayFieldTemplate={ArrayFieldTemplate}
        onChange={({ formData }) => {
          onChange(formData)
        }}
        formContext={formContext}
      >
        <button
          type="submit"
          style={{ display: "none" }}
        >
          Submit
        </button>
      </Form>
    </div>
  )
}

export default RJForm
